import { Box, Container, Grid, Typography } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import ReceptorService from "../../services/ReceptorService";
import { PaginateObj } from "../../types/Paginate/PaginateObjt";
import { AnunciosData } from "../../types/Anuncio/AnuncioData";
import { CardAnuncio } from "../../componente/Anuncio/CardAnuncio";
import { BarraBusqueda } from "../../common/Behelit/BarraBusqueda";
import { themePalette } from "../../config/theme.config";

export const HistorialPage: React.FC<{}> = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [pageData, setPageData] = useState<PaginateObj<AnunciosData>>();
    const [anuncios, setAnuncios] = useState<Array<AnunciosData>>([]);
    const [search, setSearch] = useState('');
    //region function
    const handleSearchChange = (value: string) => {
        setSearch(value);
    };

    const fetchAnuncios = async () => {
        setLoading(true)
        try {
            const response = await ReceptorService.GetHistorial();
            const data = response;
            if (response.succeeded) {
                setPageData(data)
                setAnuncios(data.data)
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }
    const fetchAnunciosByName = async () => {
        setLoading(true)
        try {
            const response = await ReceptorService.GetHistorialByName(search);
            const data = response;
            if (response.succeeded) {
                setPageData(data)
                setAnuncios(data.data)
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }
    const loadMoreAnuncios = useCallback(async () => {
        if (loadingMore || !pageData) return;// evitar multiples llamadas
        setLoadingMore(true);
        try {
            if(pageData?.nextPage !== null){
                const response = await ReceptorService.GetPage(pageData?.nextPage??'')
                const data = response;
                setPageData(data);
                //setAnuncios((prevAnuncios) => [...prevAnuncios, ...data.data])
                setAnuncios((prevAnuncios) => {
                    const newAnuncios = data.data;
                    // Filtrar los nuevos anuncios para que no se agreguen los repetidos por 'id'
                    const filteredNewAnuncios = newAnuncios.filter((newAnuncio) => 
                      !prevAnuncios.some((prevAnuncio) => prevAnuncio.idAnuncio === newAnuncio.idAnuncio)
                    );
                    // Devolver el estado actualizado con los anuncios no repetidos
                    return [...prevAnuncios, ...filteredNewAnuncios];
                  });  
            }      
        } catch (error) {
            console.error("Error loading more: ", error);
        } finally {
            setTimeout(() => {
                setLoadingMore(false);
            }, 1000);
        }
    }, [loadingMore,pageData,anuncios]);
    //endregion
    //region useEffect
    useEffect(() => {
        fetchAnuncios();
    }, []);
    useEffect(() => {
        const handleScroll = () => {
          const scrollPosition = window.innerHeight + document.documentElement.scrollTop;
          const threshold = document.documentElement.offsetHeight - 500;
          if (scrollPosition >= threshold) {
            loadMoreAnuncios();
          }
        };
      
        window.addEventListener("scroll", handleScroll);
        // Limpiar el evento cuando el componente se desmonte o se actualice
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }, [loadMoreAnuncios]);
      useEffect(() => {
        if(search.length === 0){
            fetchAnuncios();
        }
        if(search.length < 3) return;
        const debounce = setTimeout(() => {
            fetchAnunciosByName()
        },500)
        function cleanup(){
            clearTimeout(debounce)
        }
    },[search])
    //endregion
    return (
        <Container maxWidth="lg" style={{ marginTop: 10, padding: '20px', textAlign: 'center' , border: `1px solid ${themePalette.NAVCOLOR}`, borderTopWidth: '3px', borderRadius: '5px'}}>
            <Box sx={{ display: 'flex' }}>
                <Typography variant="h4" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: `${themePalette.NAVCOLOR}` }}>
                    HISTORIAL
                </Typography>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <BarraBusqueda id={"busqueda"} customStyles={{m: 1, width: '100%'}} input={search} onChange={handleSearchChange}/>
            </Box>
            <Box sx={{ display: 'flex' }}>
                {/* Contenido principal */}
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 3,
                    }}
                >
                    {loading ?
                        <CircularProgress />
                        :
                        <Grid container spacing={2}>
                            {anuncios.map((anuncio, index) => (
                                <Grid item key={`${anuncio.idAnuncio}-${index}`} xs={12} sm={6} md={3}>
                                    <CardAnuncio anuncio={anuncio} />
                                </Grid>
                            ))
                            }
                        </Grid>
                    }
                </Box>
            </Box>
        </Container>
    )
}